import { encodePageUrlasBase64 } from '../utils/retryUtils.js';
import GenericApiAdapter from './genericApiAdapter.js';

class RetryPaymentApiAdapter {
    apiAdapter;
    domain;
    locale;
    constructor(apiBaseUrl, domain, locale) {
        this.apiAdapter = new GenericApiAdapter(apiBaseUrl, {});
        this.domain = domain;
        this.locale = locale;
    }
    async get(url, headers = {}, queryParams) {
        const newHeaders = {
            ...headers,
            'Content-type': 'application/json',
            'X-Original-Host': this.domain,
            'Accept-Language': this.locale,
        };
        const response = await this.apiAdapter.get(url, newHeaders, queryParams);
        return response;
    }
    async post(url, body, headers = {}) {
        const newHeaders = {
            ...headers,
            'Content-type': 'application/json',
            'X-Original-Host': this.domain,
            'Accept-Language': this.locale,
        };
        const response = await this.apiAdapter.post(url, body, newHeaders);
        return response;
    }
    async getRetryPaymentData(customerId, orderId, shopBundle) {
        const pathUrlBase64 = encodePageUrlasBase64();
        return this.get(`/${customerId}/handle-retry-payment/${orderId}/${shopBundle}`, undefined, { originalURL: pathUrlBase64 });
    }
    async initiatePayment(payload) {
        return this.post('/initiate-retry-payment', payload);
    }
    async processPaymentAuthorization(payload) {
        return this.post('/initiate-process-psp-response', payload);
    }
}

export { RetryPaymentApiAdapter as default };
//# sourceMappingURL=retryApiAdapter.js.map
